import React from 'react'
import "./SectionFour.css"

const SectionFour = () => {
  return (
    <div className='SectionFour'>
        <img src="https://ableton-production.imgix.net/about/poster-meet-the-makers.jpg?auto=format&dpr=2&fit=crop&fm=jpg&ixjsv=1.1.3&q=50&w=1067" alt="" />
    </div>
  )
}

export default SectionFour